import { ProductImage } from "../../../services/types/productImage.type";
import { photoTypes } from "../../../utils/photoTypes";
import { PhotoTypeSelect } from "../../ui/status/PhotoTypeSelect/PhotoTypeSelect";
import "./PhotoItem.css";
import arrowLeft from "../../../assets/icons/arrow-left.png";
import arrowRight from "../../../assets/icons/arrow-right.png";
import cross from "../../../assets/icons/close.png";
import { IconButton } from "../../ui/buttons/IconButton/IconButton";

interface PhotoItemProps {
  photo: ProductImage;
  index: number;
  updatePhotoField: (
    index: number,
    field: keyof ProductImage,
    value: string,
  ) => void;
  movePhoto: (index: number, direction: "up" | "down") => void;
  deletePhoto: (index: number) => void;
}

// Получаем адрес gateway из переменных окружения
const gatewayUrl = process.env.REACT_APP_GATEWAY_URL || "";

export const PhotoItem = ({
  photo,
  index,
  updatePhotoField,
  movePhoto,
  deletePhoto,
}: PhotoItemProps) => {
  const getImageSrc = () => {
    if (photo.imageUrl) {
      return gatewayUrl + photo.imageUrl;
    }
    if (photo.file) {
      return URL.createObjectURL(photo.file);
    }
    return "";
  };

  return (
    <div
      className="photo-item"
      style={{
        backgroundImage: `url(${getImageSrc()})`,
      }}
    >
      <div className="photo-item-delete">
        <IconButton
          icon={cross}
          action={() => deletePhoto(index)}
          width="1.5rem"
        />
      </div>
      <div className="photo-item-arrow-left">
        <IconButton icon={arrowLeft} action={() => movePhoto(index, "up")} />
      </div>
      <div className="photo-item-arrow-right">
        <IconButton icon={arrowRight} action={() => movePhoto(index, "down")} />
      </div>
      <PhotoTypeSelect
        items={photoTypes}
        value={photo.imageType}
        setType={(e) => updatePhotoField(index, "imageType", e.target.value)}
      />
    </div>
  );
};
